export default __webpack_public_path__ + "f3b0da50a9a32cbade91013f61a68abc.svg";